<script>
    import { createEventDispatcher } from "svelte";
    import {
        Modal,
        ModalBody,
        ModalHeader,
        Input,
        Button,
        Label,
        Icon,
        InputGroup,
    } from "sveltestrap";
    import l from "./utils/locale";
    const dispatch = createEventDispatcher();
    export let isShowSetting;
    export let settingEnableAutocrop;
    export let settingScale;
    export let settingMaxAutocrop;

    const toggle = () => (isShowSetting = !isShowSetting);
</script>

{#if isShowSetting}
    <Modal size="md" isOpen={isShowSetting} {toggle} class="my-modal">
        <ModalHeader {toggle}
            ><Icon name="nut-fill" color="white" size="sm" />
            {l.settings}</ModalHeader
        >
        <ModalBody class="my-modal-body" />
        <div class="settings-body">
            <InputGroup floating>
                <Label for="settingEnableAutocrop">
                    {l.settingEnableAutocrop}
                </Label>
                <Input
                    class="range-filters"
                    bind:checked={settingEnableAutocrop}
                    id="settingEnableAutocrop"
                    name="settingEnableAutocrop"
                    type="checkbox"
                />
            </InputGroup>
            <InputGroup floating>
                <Label for="settingScale">
                    {l.settingScale}
                </Label>
                <Input
                    on:input={() => dispatch("settingsChanged")}
                    class="range-filters"
                    bind:checked={settingScale}
                    id="settingScale"
                    name="settingScale"
                    type="checkbox"
                />
            </InputGroup>
            <InputGroup floating>
                <Label for="settingMaxAutocrop">
                    {l.settingMaxAutocrop}{" "}
                    {settingMaxAutocrop}
                </Label>
                <Input
                    on:change={() => dispatch("settingsChanged")}
                    class="range-filters"
                    bind:value={settingMaxAutocrop}
                    min={1}
                    max={20}
                    id="settingMaxAutocrop"
                    name="settingMaxAutocrop"
                    type="range"
                />
            </InputGroup>
        </div>
    </Modal>
{/if}

<style>
    .settings-body {
        padding: 15px;
    }

    :global(.form-label) {
        padding-right: 15px;
        font-size: 16px;
        text-transform: capitalize;
    }

    :global(.input-group) {
        margin-bottom: 15px;
    }
</style>
